module.exports = __webpack_public_path__ + "static/img/Bachelor_010663.a97b75d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010663.jpg
// module id = 208
// module chunks = 0